<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="11"
            categoryName="Gas Handler"
            categorySectionIcon="fa-wrench"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'gas-handler',
    components: { BaseInventory }
}
</script>
